export class ResourceGroupNameCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "resourceGroupNames",
            "baseName": "resourceGroupNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceGroupNameCondition.attributeTypeMap;
    }
    constructor() {
    }
}
